/* DINOTY product page: quantity steppers, Ajax "Add to cart" for .dn-buy__ctrl, "See More" on the description card.
   Works on dynamically re-rendered sections (variant changes) because everything is delegated or re-scanned. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-dn-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input[name="quantity"]');
    var n = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.dnStep));
    input.value = n;
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.dn-buy__ctrl');
    if (!form) return;
    var sub = e.submitter;
    e.preventDefault();
    if (sub && sub.name === 'checkout') {
      // Buy Now = this product only: start from an empty cart, then go straight to checkout.
      if (form.dataset.buying) return;
      form.dataset.buying = '1';
      var qty = Math.max(1, parseInt(form.elements.quantity.value, 10) || 1);
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function () {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: qty }] })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          delete form.dataset.buying;
          if (res.status) { sub.textContent = res.description || res.message; return; }
          window.location.href = (window.dnCheckoutUrl && window.dnCheckoutUrl()) || (root + 'checkout');
        })
        .catch(function () { delete form.dataset.buying; form.submit(); });
      return;
    }
    var btn = form.querySelector('[data-dn-buy-add]');
    if (!btn || btn.classList.contains('is-loading')) return;
    var label = btn.textContent;
    btn.classList.add('is-loading');
    var body = { items: [{ id: Number(form.elements.id.value), quantity: Math.max(1, parseInt(form.elements.quantity.value, 10) || 1) }] };
    var ids = sectionIds();
    if (ids.length) body.sections = ids.join(',');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status) { btn.textContent = res.description || res.message; setTimeout(function () { btn.textContent = label; }, 2500); return; }
        btn.classList.add('is-done');
        btn.textContent = btn.dataset.added || '✓';
        setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 1800);
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: {}, sourceId: 'dn-buy', data: { source: 'dn-buy', itemCount: body.items[0].quantity, variantId: String(body.items[0].id), sections: res.sections } };
        btn.dispatchEvent(ev);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  function setupDesc(box) {
    if (box.__dn) return;
    box.__dn = true;
    var body = box.querySelector('[data-dn-desc-body]');
    var btn = box.querySelector('[data-dn-desc-toggle]');
    if (!body || !btn) return;
    body.dataset.collapsed = 'true';
    if (body.scrollHeight <= 50) { body.dataset.collapsed = 'false'; return; }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = body.dataset.collapsed === 'true';
      body.dataset.collapsed = open ? 'false' : 'true';
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
    });
  }

  function placeTag() {
    var tag = document.querySelector('[data-dn-express]');
    var gal = document.querySelector('main[data-template="product"] media-gallery');
    if (tag && gal && tag.parentElement !== gal) { gal.appendChild(tag); tag.hidden = false; }
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-dn-desc]').forEach(setupDesc);
    placeTag();
  }

  scan();
  new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
